<template>
    <fade-up-animation :element="() => $refs.section">
        <section
            class="card-columns-section"
            ref="section"
        >
            <b-container>
                <mobile-gutter>
                    <b-row>
                        <b-col
                            v-for="column in columns"
                            :key="column.id"
                            sm="4"
                        >
                            <div class="column-card">
                                <lazy-image
                                    v-if="column.image.src"
                                    :src="column.image.src"
                                    :alt="column.image.alt"
                                    :width="column.image.width"
                                    :height="column.image.height"
                                    v-test:image
                                />

                                <markdown-content
                                    v-if="column.text"
                                    class="text"
                                    :content="column.text"
                                    v-test:text
                                />
                            </div>
                        </b-col>
                    </b-row>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';

    export default {
        name: 'card-columns-section',

        components: { MarkdownContent },

        props: {
            columns: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    $gutter: 12px;

    .card-columns-section {
        padding: (65px - $gutter) 0;
    }

    .row {
        margin: 0 -$gutter;

        > * {
            padding: 0 $gutter;
        }
    }

    .column-card {
        padding: $gutter 0;
    }

    img {
        width: 100%;
        height: auto;

        &:not(:last-child) {
            margin-bottom: $gutter * 1.5;
        }
    }

    .text ::v-deep {
        h2, h3, h4, h5 {
            font-size: map-get($heading-font-sizes-mobile, h6);
            font-weight: bold;

            @include media-breakpoint-up(lg) {
                font-size: map-get($heading-font-sizes-desktop, h6);
            }
        }

        p:last-child {
            margin-bottom: 0;
        }
    }
</style>
